<template>
  <div class="supplier_process pt-4">
    <div  v-if="!this.processGroups || this.processGroups.length === 0">
      <v-container>
         <v-row>         
          <v-col>
            <span>登録されていません</span>
          </v-col>        
        </v-row>
      </v-container>
    </div>
    <div v-else>
      <v-container>    
        <v-row >
          <v-col cols="6" v-for="pg in this.processGroups" :key="pg.processGroupCd">

            <v-card>
              <v-card-title>
                <v-list-item>
                  <v-list-item-content>
                    <v-list-item-title class="mb-1">
                      {{ pg.processGroupName }}
                    </v-list-item-title>
                  </v-list-item-content>
                  <v-list-item-action>
                    <!-- <a v-on:click.prevent="onEditClick"><v-icon>mdi-pencil-box</v-icon></a> -->
                  </v-list-item-action>
                </v-list-item>
              </v-card-title>
              <v-card-text>

                <v-container class="my-0 py-0">
                  <v-row>
                    <v-col cols="6" class="my-0 py-0">
                      <div v-for="process in pg.processes" :key="process.processCd">
                        {{process.processName}}
                      </div>
                    </v-col>
                    <v-col cols="6" class="my-0 py-0">
                      <div v-for="ss in pg.availableSizes" :key="ss.itemCd" class="mx-1">
                        <span>{{ss.name}}</span>
                        <span v-if="ss.useRange">{{ss.value1}}〜{{ss.value2}}</span>
                        <span v-else>{{ss.value1}}</span>
                        <span>{{ss.unit}}</span>
                      </div>
                    </v-col>
                  </v-row>
                  <v-row>
                    <v-col>
                      <v-chip-group column v-if="pg" >
                        <v-chip v-for="mat in pg.materials" :key="mat.materialCd" outlined small color="indigo"> {{mat.materialName}} </v-chip>
                        <v-chip v-for="mats in pg.materialFaces" :key="mats.materialFaceCd" outlined small color="orange" > {{mats.materialFaceName}} </v-chip>
                        <v-chip v-for="chip in pg.tags" :key="chip.name" outlined small color="grey" > {{chip}} </v-chip>
                      </v-chip-group>
                    </v-col>
                  </v-row>

                </v-container>

              </v-card-text>
            </v-card>

          </v-col>
        </v-row>

      </v-container>

      <v-divider class="mt-3 mb-3"/>
    </div>

  </div>
</template>
<script>

import ObjectParamSupport from "@/components/ObjectParamSupport";
import BaseView from "@/components/BaseView";

export default {
  mixins: [BaseView, ObjectParamSupport],
  components: {},
  props: {
    processGroups: Array
  },
  data: () => ({
    isInitialized: false,
    isFetched: false,
    isLoading: false,
    isDownloading: false,


    process_groups: [
      {
        process_group:"",
        process_group_name: "test",
        processes:[
          {
            process_cd:"",
            process_group_cd:"",
            process_name:"",
          }
        ],
        tags: [
          {id: 0, name: ""}
        ],
        materials: [
          {
            id: 0,
            material_cd: "",
            name: ""
          }
        ],
        materialFaces: [
          {
            id: 0,
            material_face_cd: "",
            name: ""
          }
        ],
        sizeSet: [
          {
            itemCd: "",
            name: "",
            unit: "",
            useRange: false,
            value1: null,
            value2: null,
          }
        ],
      }
    ],

    condition: {},
    pager: {},
    errors: {},
  }),
  computed: {},
  mounted: function () {
    this.setupConditions();
    this.updateData();
  },
  created: function () {
  },
  watch: {
    '$route': function (to, from) {
      this.setupConditions();
    },
    'process': function (to, from) {
      this.updateData();
    },
  },
  methods: {
    setupConditions() {
      let p = this.getObjectParam();
      if (p) {
        // パラメータの転写
      }
    },

    fetchData(needDataFetch) {
      let self = this;
      if (!this.isInitialized) {
        this.fetchBasicData(function () {
          self.fetchData(needDataFetch)
        });
        return;
      }
      if (needDataFetch) {
        this.isLoading = true;
        Promise.resolve()
            .then(data => {
              //
            })
            .catch(function (err) {
              console.log(err);
              self.showErrorToast("データの取得に失敗しました。");
            });
      }
    },

    fetchBasicData(finishProc) {
      this.isInitialized = true;
      if (finishProc) {
        finishProc();
      }
    },

    updateData() {

      this.process_groups.splice(0)

      let groups = this.processGroups.map(procGroup => {
        let parentGroupCd = procGroup.process_group;
        return procGroup
      })

      console.log("updateData - groups")
      console.log(groups)

      groups.forEach(v => {
        this.process_groups.push(v)
      })

    },

  },

}
</script>